export default __webpack_public_path__ + "static/media/aws-certified-solutions-architect-associate.a87bc354.png";